<template>
  <vx-card no-shadow v-if="showWindow">
    <h3>Notes</h3>
    <vs-popup classContent="popup-example" title="Add note" :active.sync="popupActive">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="User" v-model="$route.params.email" disabled/>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Headline" v-model="params.headline" />
        </div>
      </div>
       <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Note" v-model="params.note1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Sale status
          <v-select v-model="params.sales_status" :options="saleStatus" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>      
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('insert-note')" color="primary" type="filled">Save</vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="popupActive=true">New note</vs-button>
    </div>
    <vs-table max-items="5" pagination :data="tableData">
            <template slot="thead">
                <vs-th>agent</vs-th>
                <vs-th>created_at</vs-th>
                <vs-th>headline</vs-th>
                <vs-th>id</vs-th>
                <vs-th>note</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                   <vs-td :data="data[indextr].agent">
                        {{data[indextr].agent}}
                    </vs-td>
                    <vs-td :data="data[indextr].created_at">
                        {{data[indextr].created_at}}
                    </vs-td>
                    <vs-td :data="data[indextr].headline">
                        {{data[indextr].headline}}
                    </vs-td>
                    <vs-td :data="data[indextr].id">
                        {{data[indextr].id}}
                    </vs-td>
                    <vs-td :data="data[indextr].note">
                        {{data[indextr].note}}
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
  </vx-card>
</template>

<script>
import axios from "@/axios.js"
import vSelect from 'vue-select';
import saleStatus from '../../../resources/sale_status.json';
export default {
  data() {
    return {
      popupActive: false,
      params: {},
      saleStatus:saleStatus,
      tableData:[]
    }
  },
  components:{
    'v-select': vSelect,
  },
  computed: {
    showWindow(){
      if(this.$route.path.indexOf('/clients/')!==-1){
        //if(this.fieldsData.length===0)
          this.setData();
        return true;
      }
      return false;
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
  methods:{
    setData: function(){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', 'get-notes');
      params.append('email', this.$route.params.email);
      axios.post("/api/client",params)
      .then((response) => {
        that.tableData.splice(0);
        for(let i in response.data){
          this.tableData.push(response.data[i]);
        }
      })
      .catch((error) => { console.log('error',error) })
    },
    sendData: function(type){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', type);
      params.append('headline', this.params.headline);
      params.append('sales_status', this.params.sales_status);
      params.append('note1', this.params.note1);
      params.append('email', this.$route.params.email);
      this.$vs.loading();
      axios.post("/api/client",params)
      .then((data) => {
        that.setData(true);
        that.$vs.loading.close();
        that.params = {};
        if(data.data[0].out1==='done!' || data.data[0].out1==='inserted note!'){
          that.popupActive = false;
          that.openAlert('success','Success',data.data[0].out1);
        } else
          that.openAlert('danger','Failed',data.data[0].out1);
      })
      .catch((data) => { that.$vs.loading.close(); that.openAlert('danger','Failed',data[0].out1); })
    },
    openAlert(color,title,text) {
      let colorAlert = color;
      this.$vs.notify({
          title: title,
          text: text,
          color: colorAlert
      })
    },
  }
}
</script>
